var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 15,
  viewBox: "0 0 20 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.5 10.54s.437-1.446 1.601-3.01c.49-.66 1.328-1.245 2.525-1.959 2.146-1.28 6.446-1.574 6.446-1.574V0L20 7.528 11.072 15v-3.985s-5.721.126-7.406.697c-1.304.442-2.416 1.644-2.555 2.757-.042.333-1.111.306-1.111.306z"
})));
export default SvgGoogleMobileShare;